import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from 'app/common/toast-alert/toast.service';
import { GlobalsService } from 'app/globals-services/globals.service';
import { Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class BrandFactoryConnectionService {

    baseHref = environment.baseHref;

    commonSubject$ = new Subject();

    constructor(
        private http: HttpClient,
        private globalService: GlobalsService,
        private toastService: ToastService
    ) { }

    searchFactoryByList(data) {
        return this.http.post<any[]>(this.baseHref + '/searchFactory', data);
    }

    searchBrandByList(data) {
        return this.http.post<any[]>(this.baseHref + '/searchBrand', data);
    }

    addConnectionRequest(data) {
        return this.http.post<any[]>(this.baseHref + '/addConnectionRequest', data);
    }

    sentConnectionRequestCount(data) {

        return this.http.post<any[]>(this.baseHref + '/sentConnectionRequestCount', data);
    }

    sentConnectionRequestList(data) {

        return this.http.post<any[]>(this.baseHref + '/sentConnectionRequestList', data);
    }


    receivedConnectionRequestCount(data) {
        return this.http.post<any[]>(this.baseHref + '/receivedConnectionRequestCount', data);
    }

    receivedConnectionRequestList(data) {
        return this.http.post<any[]>(this.baseHref + '/receivedConnectionRequestList', data);
    }

    brandConnectionRequestUpdate(data: { isAccept: any; id: any; }) {
        return this.http.post<any[]>(this.baseHref + '/brandConnectionRequestUpdate', data);
    }

    uploadExcelMatchFactories(formData: FormData) {
        return this.http.post<any[]>(this.baseHref + '/uploadExcelMatchFactories', formData).pipe(
            catchError(this.handleError));
    }

    downloadOrgDataInExcel(data) {

        return this.http.get(this.globalService.baseHref + `/downloadTemplate/` + data, { responseType: 'blob' }).pipe(
            catchError(this.handleError));

    }


    addMultipleConnection(checkedData) {
        return this.http.post<any[]>(this.baseHref + '/addMultipleConnection', checkedData).pipe(
            catchError(this.handleError));
    }

    handleError(error) {
        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {

            // client-side error
            //     errorMessage = Error: ${error.error.message};

        } else {
            // server-side error
            // errorMessage = Error Code: ${error.status}\nMessage: ${error.message};

        }
        this.globalService.hideSpinner();
        this.toastService.error(errorMessage);

        return throwError(errorMessage);

    }

    enableVisibilityToBrandInConnRequest(data) {
        return this.http.post<any[]>(this.baseHref + '/updateFactoryProfileNameVisibiltyStatus', data);
        // console.log(data)
    }

    deleteConnectionRequest(id) {
        return this.http.get<any[]>(this.baseHref + '/deleteConnectionRequest/' + id);
    }

}
